import React, {Component} from "react";
import {connect} from "react-redux";

import SubNavTabs from "./../../components/nav/SubNavTabs";

import Introduction from "./../../components/blocks/Introduction";
import ClearD3PlusContext from "./../../components/items/ClearD3PlusContext";

//Intro slide
import AverageValuesPerClusters from "./../../components/slides/regional-cluster/intro/AverageValuesPerClusters";
import ClustersProfile from "./../../components/slides/regional-cluster/intro/ClustersProfile";

//TODAY Slides cluster
import LaborMarketOutcomes from "./../../components/slides/regional-cluster/today/cluster/LaborMarketOutcomes";
import LaborMarketSupply from "../../components/slides/regional-cluster/today/cluster/LaborMarketSupply";
import LaborMarketDemand from "../../components/slides/regional-cluster/today/cluster/LaborMarketDemand";

//TODAY Slides region
import LaborMarketOutcomesRegion from "./../../components/slides/regional-cluster/today/region/LaborMarketOutcomesRegion";
import CurrentSectorMix from "../../components/slides/regional-cluster/today/region/CurrentSectorMix";
//import CurrentOccupationalMix from "../../components/slides/regional-cluster/today/region/CurrentOccupationalMix";


//2030 Slides cluster
import DemandOutlook from "../../components/slides/regional-cluster/outlook/cluster/LaborMarketDemand";
import LaborSkillShifts from "../../components/slides/regional-cluster/outlook/cluster/LaborSkillShifts";
import ProjectedOccupationalChanges from "../../components/slides/regional-cluster/outlook/cluster/ProjectedOccupationalChanges";

//2030 slides regions
import LaborMarketDevelopment from "../../components/slides/regional-cluster/outlook/region/LaborMarketDevelopment";
import ProjectedOccupational from "../../components/slides/regional-cluster/outlook/region/ProjectedOccupational";



import {loadDataAction, setMapDataAction, startOverMapAction} from "./../../actions/DataAction";

import {VIEWS, FILE_KEYS} from "./../../helpers/consts";

import "./RegionalCluster.css";


class RegionalCluster extends Component {

  componentDidMount() {
    this.props.setMapDataAction(VIEWS.REGIONAL_CLUSTER);
    this.props.loadDataAction([
      FILE_KEYS.OCCUPATIONAL_CLUSTERS,
      FILE_KEYS.OCCUPATIONAL_EU,
      FILE_KEYS.CLUSTERS_AVG_PRESENT,
      FILE_KEYS.NUTS3_FUTURE,
      FILE_KEYS.NUTS3_TOP_OCCUPATIONS_FUTURE,
      FILE_KEYS.OCCUPATIONAL_DATA
    ], this.props.db);
    this.props.startOverMap();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.geojson !== this.props.geojson) {
      this.props.setMapDataAction(VIEWS.REGIONAL_CLUSTER);
    }
  }

  render() {
    const {selectedRegion, selectedCluster, width} = this.props;
    const selectedItem = selectedRegion || selectedCluster;

    return (
      <div id="fow-view-regional-cluster">
        <SubNavTabs baseUrl={`/map/${VIEWS.REGIONAL_CLUSTER}`}>
          <>
            <Introduction title="Applying a local lens">
              <div className="fow-col fow-col-1-3 fow-md-col-1 fow-introduction-block-children">
                <p className="fow-font-text fow-font-size-md">The labor market that matters to most people is the one where they live. Even within a single country, local economies vary significantly.</p>
                <p className="fow-font-text fow-font-size-md">With this in mind, we gathered extensive data on 1,095 local labor markets across Europe and sorted them using a mathematical clustering technique. The locations within each of the resulting 13 clusters share commonalities in demographics, growth trends, skill levels, industry mix, business dynamism, innovation capabilities, and other characteristics.</p>
                <p className="fow-font-text fow-font-size-md">These 13 clusters broadly fit into three sets: dynamic growth hubs, stable economies, and shrinking regions. This perspective allows us to understand differences between local economies today and map the potential effects of automation in the future.</p>
              </div>
              <ClustersProfile/>
            </Introduction>
            {width > 1120 &&
              <Introduction title="Each cluster has a distinct economic and labor market profile" subtitle="Average values per clusters (2013-18)">
                <div className="fow-col fow-col-1">
                  <AverageValuesPerClusters />
                </div>
              </Introduction>
            }
          </>
          <>
            {selectedItem.type === 'Cluster' &&
              <>
                <LaborMarketOutcomes />
                <LaborMarketSupply />
                <LaborMarketDemand />
              </>
            }
            {selectedItem.type === 'Region' &&
              <>
                <LaborMarketOutcomesRegion/>
                <CurrentSectorMix />
              </>
            }
          </>
          <>
            {selectedItem.type === 'Cluster' &&
              <>
                <ClearD3PlusContext>
                  <DemandOutlook />
                </ClearD3PlusContext>
                <LaborSkillShifts />
                <ProjectedOccupationalChanges />
              </>
            }
            {selectedItem.type === 'Region' &&
              <>
                <ClearD3PlusContext>
                  <LaborMarketDevelopment />
                </ClearD3PlusContext>
                <ProjectedOccupational />
              </>
            }
          </>
        </SubNavTabs>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    geojson: state.db.map.geojsonOptions[VIEWS.REGIONAL_CLUSTER],
    db: state.db,
    selectedRegion: state.settings.map["Regions"],
    selectedCluster: state.settings.map["Clusters"],
    width: state.settings.window.width
  };
};
const mapDispatchToProps = dispatch => ({
  startOverMap: () => dispatch(startOverMapAction()),
  loadDataAction: (keys, db) => dispatch(loadDataAction(keys, db)),
  setMapDataAction: (view) => dispatch(setMapDataAction(view)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegionalCluster);
